import ServiceTag, { TagGroup } from 'components/ServiceTag';

const t = {
  prio: 'PRIO',
  new: 'FTB',
  recovering: 'Recovering',
};

const statsTags = {
  recovering: <ServiceTag skin="accent" textTransform="uppercase" text={t.recovering} />,
  new: <ServiceTag skin="success" textTransform="uppercase" text={t.new} />,
  prio: <ServiceTag skin="primary" textTransform="uppercase" text={t.prio} />,
};

const TagsGroup = ({ isPriority, isRecovering, isNew }) => {
  return (
    <TagGroup>
      {isPriority && statsTags.prio}
      {isNew && statsTags.new}
      {isRecovering && statsTags.recovering}
    </TagGroup>
  );
};
export default TagsGroup;
